import { useEffect, useState } from 'react'
import { message, Modal, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useJoinCooperate } from '../cooperateModel'
import { FileWordOutlined, } from '@ant-design/icons'
import { globalPrompt } from '@/components/message'
import useNavModel from '@/model/navModel'
import YhTootip from '@/components/YhTootip'

import { FranchiseePageResult, intentionService } from '../../intention/intentionService'
import { useDictModel } from '@/views/base/dict/dictModel'
import { getBaseImgLookUrl } from '@/utils/constants'
import useGlobalModel from '@/model/globalModel'
import { FanchiseeStatus, FanchiseeStatusEnum } from '@/types/AppEnums'

const sortKey = 'baseMaintenanceArchives'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys, updateEditFormVal } = useJoinCooperate()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const { getTreeNodeName } = useDictModel()
    const {
        setOfficeLookInfo,
    } = useGlobalModel()
    useEffect(() => {
        loadData()
    }, [])
    const onEdit = (record) => {
        let supplierEditKey = "2-2-1";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: "look" });
            updateEditFormVal(null);
        } else {
            globalPrompt("modal", {
                title: "合作加盟跳转详情",
                type: "warning",
                text: "您还有合作加盟详情未关闭，是否跳转",
                okText: "跳转未关闭页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: record?.id, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const onConfirm = (record) => {
        Modal.confirm({
            title: '确定',
            centered: true,
            closable: true,
            content: '确定要变更状态为已完成？',
            async onOk() {
                let { retData } = await intentionService.finish(record)

                //请求财务接口 初始化加盟商账户
                let fmsSupplyAccountInitParams = {
                    "fmsAccounts": [
                        {
                            "branch": "franchisee",
                            "accountTypeCode": "account-type.credit-month",
                            "accountTypeName": "月结账户",
                            "shopCode": "SHOP-M-00000086",
                            "shopName": "加盟商管理",
                            "beCode": "bentity.bj-yh-auto-service",
                            "beName": "云豪车服（北京）科技服务有限公司",
                            "creditFlag": 1
                        }
                    ],
                    "mdCustomers": [{ "code": retData.code, "name": retData.name }],
                    "type": "1",
                    "sourceApp": "franchisee"
                }

                let ret = await intentionService.fmsSupplyAccountInit(fmsSupplyAccountInitParams);
                if (ret.retData.indexOf('重新上传') > 0) {
                    message.error(`初始化加盟商账户失败`)
                }

                message.success(`${record.name}状态已变更为已完成`)
                loadData()
            },
        })
    }



    const defaultColumns: ColumnsType<FranchiseePageResult> = [
        {
            title: '序号',
            width: 70,
            fixed: 'left',
            render: (t, r, i) => i + 1,
            align: 'center',
        },
        {
            title: '操作',
            width: 120,
            fixed: 'left',
            render: (t, r) => (
                <>
                    <span
                        style={{ color: '#4165E3', cursor: 'pointer' }}
                        onClick={() => {
                            onEdit(r)
                        }}
                    >
                        详情
                    </span>
                    {
                        r.status === FanchiseeStatusEnum.FRANCHISEE_STATUS_RECEIVED && <span style={{ color: '#4165E3', cursor: 'pointer', marginLeft: '20px' }} onClick={() => { onConfirm(r) }}>确认</span>
                    }

                </>
            ),
        },
        {
            title: '加盟商编号',
            width: 140,
            dataIndex: 'code',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />
        },
        {
            title: '加盟商名称',
            width: 140,
            dataIndex: 'name',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />
        },
        {
            title: '负责人',
            width: 140,
            dataIndex: 'contact',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />
        },
        {
            title: '电话',
            width: 140,
            dataIndex: 'phone',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />
        },
        {
            title: '地址',
            width: 140,
            dataIndex: 'address',
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />
        },
        {
            title: '协议状态',
            width: 100,
            dataIndex: 'status',
            render: (text) => <YhTootip text={FanchiseeStatus[text]} style={{ width: '120px' }} />
        },
        {
            title: '经营性质',
            width: 100,
            dataIndex: 'businessNature',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '业务经理',
            width: 110,
            dataIndex: 'businessManager',
            render: (text) => <YhTootip text={text} style={{ width: '110px' }} />,
        },
        {
            title: '加盟类型',
            width: 110,
            dataIndex: 'franchiseType',
            render: (text) => <YhTootip text={getTreeNodeName(text)} style={{ width: '110px' }} />,
        },
        {
            title: '合同附件',
            width: 210,
            dataIndex: 'cooperationAgreementList',
            render: (text) => text?.length > 0 ? <div onClick={() => { setOfficeLookInfo({ visible: true, url: getBaseImgLookUrl(text[text.length - 1].md5) }) }}><FileWordOutlined style={{ fontSize: '16px', cursor: 'pointer' }} /><span style={{ fontSize: '14px', cursor: 'pointer', color: '#4165E3' }}>{text[text.length - 1].fileName}</span></div> : <></>
        },
    ]

    //点击行选高亮
    const onRow = (record: FranchiseePageResult) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }
    return (
        <>
            <Table
                rowKey={(record) => record.id}
                columns={defaultColumns}
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomRight"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record])
                    },
                })}
            />
        </>
    )
}
